export default "__VITE_ASSET__BuoKqgPz__"